import { Order } from '@/data/usecases/order/order'
import { EnrollmentRestriction } from '@/domain/models/content/enrollment/enrollment-restriction'
import {
  FormattedUserEnrollmentContentInfo,
  UserEnrollmentContentInfoResponse
} from './user-enrollment-content-info-service-types'

export const formatUserEnrollmentContentInfo = (
  data: UserEnrollmentContentInfoResponse
): FormattedUserEnrollmentContentInfo | null => {
  if (!data) return null

  return {
    restricted: data.restricted,
    restrictionMessage: data.restrictionMessage,
    restrictionType: EnrollmentRestriction.getByName(data.restrictionType),
    infoMessages: data.infoMessages,
    customAttributesInfo: data.customAttributesInfo,
    lastOrder: data.lastOrder
      ? {
          id: data.lastOrder.id,
          productId: data.lastOrder.productId,
          status: Order.Status.getByName(data.lastOrder.status)
        }
      : null,
    biometryRequired: data.biometryRequired
  }
}
